import { useMemo, useState } from 'react'

export type SortOrder = 'asc' | 'desc' | 'none'

export type SortingTab = {
  id: string
  label: string
  order?: SortOrder
  isActive?: boolean
  withoutOrder?: boolean
}

interface IHorizontalSorting {
  tabs: SortingTab[]
}

const defaultToggleOrder = (tab: SortingTab): SortOrder => {
  if (tab.withoutOrder) {
    return 'none'
  }
  return !tab.order || tab.order === 'asc' || tab.order === 'none'
    ? 'desc'
    : 'asc'
}

const useHorizontalSorting = ({ tabs }: IHorizontalSorting) => {
  const [state, setState] = useState<SortingTab[]>(tabs)
  const sorting = useMemo(() => {
    return state
      ?.filter((item) => item?.isActive)
      ?.map((item) => {
        return { id: item.id, order: item.order ?? 'none' }
      })
  }, [state])

  const toggleTab = (id: string, order?: SortOrder) => {
    setState((prev) =>
      prev.map((tab) =>
        tab.id === id
          ? {
              ...tab,
              order: order ?? defaultToggleOrder(tab),
              isActive: true,
            }
          : { ...tab, order: 'none', isActive: false },
      ),
    )
  }

  return { state, sorting, toggleTab, setTabs: setState }
}

export default useHorizontalSorting
